import { Box, Button, Layer } from 'grommet';
import { Close, Menu as MenuIcon } from 'grommet-icons';
import Auth from 'modules/auth/Auth';
import React, { useState } from 'react';
import styled from 'styled-components';
import { LinkItem } from './LinkItem';

const StyledLinkItem = styled(LinkItem)`
  font-weight: 200;
  font-size: 24px;
`;

interface MiniMenuProps {
  appRouteItems: {
    route: string;
    label: string;
  }[];
}

const MiniMenu = ({ appRouteItems }: MiniMenuProps) => {
  const [open, setOpen] = useState(false);
  return (
    <>
      <Box
        width="xxsmall"
        height="xxsmall"
        pad="small"
        margin="medium"
        align="center"
        justify="center"
      >
        <Button
          fill={true}
          icon={<MenuIcon color="white" size="xmedium" />}
          onClick={() => setOpen(true)}
          plain
        />
      </Box>
      {open && (
        <Layer
          position="top-right"
          onClickOutside={() => setOpen(false)}
          full={true}
        >
          <Box background="white" fill={true}>
            <Box
              direction="column"
              margin="medium"
              fill="vertical"
            >
              <Box height="xxsmall" align="end">
                <Button
                  icon={<Close color="dark-1" size="large" />}
                  onClick={() => setOpen(false)}
                />
              </Box>
              <Box>
                {appRouteItems.map(({ route, label }: any) => (
                  <Box pad="medium" key={label}>
                    <StyledLinkItem
                      route={route}
                      label={label}
                      size="medium"
                      margin="none"
                      color="dark-1"
                      onClick={() => setOpen(false)}
                    />
                  </Box>
                ))}
                <Box pad="medium">
                  <Auth />
                </Box>
              </Box>
            </Box>
          </Box>
        </Layer>
      )}
    </>
  );
};

export default MiniMenu;
